import { useCallback, useEffect, useContext, useState } from 'react'
import { useLocation } from "react-router";
import { InfiniteScroll, Empty, SpinLoading } from 'antd-mobile'
import BpmToast from 'components/BpmToast';
import { getEmploymentHardHistory, getSocialSubsidyHistory } from 'api/api'
import { formName } from 'utils/constant';
import { UserContext } from 'utils/getContext'
import { idCardHide } from 'utils/ruleType'
import nodata from "static/images/nodata.svg";
import 'static/css/recordQuery.css'

/** 国际化 */
const { AFFIRMEMPLOY, SUBSIDY } = formName

/** 
 * 历史记录查询页
 */
function RecordsQuery() {

  const { state: { title } } = useLocation()

  const { userInfo } = useContext(UserContext)
  const [pageNo, setPageIndex] = useState(1)  // 页码
  const [detail, setDetail] = useState([])    // 数据
  const [hasMore, setHasMore] = useState(true)// 是否加载更多
  const [loading, setLoading] = useState(true)// 是否显示加载圈
  const { name, idNum } = userInfo ?? ''

  /** 标题要显示什么 */
  const getPageTitle = () => {
    switch (title) {
      case SUBSIDY:
        return '社保补贴发放历史记录'
      default:
        return `${title}历史记录`
    }
  }

  /** 根据不同的表单请求不同的接口数据 */
  const setDetails = useCallback(() => {
    switch (title) {
      case SUBSIDY:
        return getSocialSubsidyHistory(idNum, pageNo)
      default:
        return getEmploymentHardHistory(idNum, pageNo)
    }
  }, [title, idNum, pageNo])

  // 上划加载更多的回调
  const loadMore = useCallback(async () => {
    pageNo === 1 && setLoading(true)
    try {
      if (idNum) {
        const { data, success, msg } = await setDetails(title)
        const total = data?.total || 0
        const newData = data?.empHardHistoryRecordInfos || data?.socialSubsidyHistoryRecordInfos
        if (success) {
          setPageIndex(pageNo + 1)
          setDetail([...detail, ...newData])
          // setHasMore(newData.length > 0)
          setHasMore(total > detail.length)
        } else {
          BpmToast(msg)
          setHasMore(false)
        }
      }
    } catch {
      setHasMore(false)
      console.error('-------> RecordsQuery:loadMore < -------')
    } finally {
      setLoading(false)
    }
  }, [setDetails, title, detail, idNum, pageNo])

  useEffect(() => {
    if (!idNum) {
      setLoading(false)
    }
  }, [idNum])


  /** 根据不同的表单渲染不同的数据 */
  const showCard = (item) => {
    switch (title) {
      case SUBSIDY:
        return <>
          <p><b>补贴月数：</b>{item.sumMonth}</p>
          <p><b>合计金额：</b>{item.sum}</p>
          <p><b>银行账号：</b>{item.bankNum}</p>
          <p><b>补贴年度：</b>{item.appYear}</p>
          <p><b>经办机构：</b>{item.name}</p>
        </>
      case AFFIRMEMPLOY:
        return <>
          <p><b>就业困难人员类型：</b>{item.type}</p>
          <p><b>认定时间：</b>{item.identifiedTime}</p>
          <p><b>经办机构：</b>{item.agentOrg}</p>
        </>
      default:
        return null
    }
  }

  return (
    <>
      <div className='rq-top'>
        <div className='rq-basicInfo'>
          <span>姓名：{idCardHide(name, 1, name.length - 1)} </span>
          <span>身份证号码：{idCardHide(idNum)}</span>
        </div>
        <div className='rq-title'>
          {getPageTitle()}
        </div>
      </div>
      <div className='rq-bottom'>
        {
          loading ? (
            <div className='pc-loading'>
              <SpinLoading className="pc-spinLoading" />
            </div>
          ) : (
            detail?.length !== 0 ? detail.map((item, index) => (
              <div className='rq-card' key={index}>
                {showCard(item)}
              </div>
            )) : (
              <Empty
                className='rq-empty'
                image={nodata}
                description='暂无数据'
                imageStyle={{ width: 128 }}
              />
            )
          )
        }
      </div>
      {idNum && <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />}
    </>
  )
}

export {
  RecordsQuery
}